module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-02.7e4f3fb4.svg";